import React from "react";
import { Table } from "reactstrap";
import { infoTableData } from "../FakeJSONs/Infotable";

const Renderinnercontent = (props) => {
    return (
        <div className="report-notifications-inner-content">
            <h1>Reports are available based on min respondents</h1>
            <Table>
                <thead>
                    <tr>
                        <th>Sl. No</th>
                        <th>Relation Group Name/Report Style</th>
                        <th>Minimum Respondents</th>
                        <th style={{ textAlign: "left" }}>Relations</th>
                    </tr>
                </thead>
                <tbody>
                    {infoTableData.map((tableData) => {
                        return (
                            <tr key={tableData.serial_no}>
                                <td>{tableData.serial_no}</td>
                                <td>{tableData.report_style}</td>
                                <td>{tableData.min_respondants}</td>
                                <td style={{ textAlign: "left" }}>{tableData.relation}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            <div className="button-wrapper">
                <button onClick={props.handleModalClose}>Got It</button>
            </div>
        </div>
    );
};

export default Renderinnercontent;



// WEBPACK FOOTER //
// ./src/new/Utils/Button/inner-content.jsx